<template>
  <bj-modal
    v-model="sendNotificationModal.visible"
    size="auto"
    title="Send custom push notification"
  >
    <div slot="content">
      <div class="row">
        <div class="col-12">
          <q-field
            :error="!$v.payload.message.maxLength"
            error-label="178 character limit"
          >
            <q-input
              v-model="payload.message"
              type="textarea"
              :rows="3"
              inverted
              placeholder="Enter the message here"
            />
          </q-field>
        </div>
      </div>
      <div class="row justify-content-between">
        <div class="d-flex">
          <q-btn
            rounded
            label="Cancel"
            color="secondary"
            @click="$emit('close')"
          />
        </div>
        <q-btn
          :disable="$v.payload.message.$invalid"
          rounded
          color="primary"
          label="Send"
          @click="sendNotification()"
        />
      </div>
    </div>
  </bj-modal>
</template>

<script>

import { maxLength, required } from 'vuelidate/lib/validators';

export default {
  name: 'SendNotificationModal',
  props: {
    sendNotificationModal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      payload: {
        message: null,
        notification_channel: 'push',
      },
    };
  },
  validations() {
    return {
      payload: {
        message: {
          required,
          maxLength: maxLength(178),
        },
      },
    };
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    sendNotification() {
      this.api()
        .request('POST', `admin/users/${this.sendNotificationModal.user_id}/notifications `, this.payload)
        .then(() => {
          this.$emit('close');
          this.uiNotify('Notification delivered!');
        })
        .catch((error) => {
          this.uiLoading(false);
          const errorMessage = this.getFirstError(error) || error.message || 'Error occurred';
          this.uiNotify(`Delivery failed: ${errorMessage}`, 'negative', 5000);
        });
    },
  },
};

</script>
